module.exports = __webpack_public_path__ + "static/media/moises.d678ae08.png";